import { Checkbox } from "@mui/material";
import ProductsActionMenu from "./actionsMenu";
import swal from "sweetalert";
import { desactivateProduct } from "rest/requests";
import { activateProduct } from "rest/requests";

function getTableData(products, setEditing, setElementToEdit, setDeleting) {
  // param: products list of: [
  // {
  //     "createdDate": 1674688441671,
  //     "modifiedDate": 1674688531165,
  //     "createdBy": "mauricio@pksystems.com.ec",
  //     "modifiedBy": "mauricio@pksystems.com.ec",
  //     "id": 133102,
  //     "code": "666",
  //     "name": "AAMEGALEXINA",
  //     "presentation": "MM",
  //     "manufacturer": "MM",
  //     "activeMolecularCompound": "MM",
  //     "unitContent": "MM",
  //     "administration": "MM",
  //     "category": {
  //         "id": 23566,
  //         "name": "ACIDIFICANTES",
  //         "abbreviation": "ACD",
  //         "catalogTypeId": 6
  //     },
  //     "categoryId": 23566,
  //     "sector": {
  //         "id": 12,
  //         "name": "AVICULTURA",
  //         "abbreviation": "AVI",
  //         "catalogTypeId": 2
  //     },
  //     "sectorId": 12,
  //     "subSector": {
  //         "id": 16,
  //         "name": "ADITIVO",
  //         "abbreviation": "ADI",
  //         "catalogTypeId": 3
  //     },
  //     "subSectorId": 16,
  //     "group": {
  //         "id": 58,
  //         "name": "ACIDIFICANTES",
  //         "abbreviation": "ACI",
  //         "catalogTypeId": 1
  //     },
  //     "groupId": 58,
  //     "form": {
  //         "id": 206,
  //         "name": "AEROSOL",
  //         "abbreviation": "AER",
  //         "catalogTypeId": 7
  //     },
  //     "formId": 206,
  //     "company": {
  //         "id": 1,
  //         "code": "AEN",
  //         "name": "AENSA",
  //         "representative": "Francisco Troya",
  //         "telephone": "026009999"
  //     },
  //     "companyId": 1,
  //     "active": false
  // },
  //  ]

  const changeState = (isActive, productId) => {
    var action = isActive ? desactivateProduct : activateProduct;
    setDeleting(false);
    swal({
      title: "Confirmación",
      text: "Esta seguro de cambiar el estado del producto",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willChange) => {
      if (willChange) {
        action(productId)
          .then((req, res) => {
            console.log("Success..", res);
            setDeleting(true);
          })
          .catch((error) => {
            console.log("Error...", error);
            swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
          });
      }
    });
  };

  var rows = [];
  products.forEach((elem, index) => {
    var _temp = {
      Nro: index + 1,
      Codigo: elem.code,
      Nombre: elem.name,
      Fabricante: elem.manufacturer,
      Presentacion: elem.presentation,
      Administracion: elem.administration,
      unitContent: elem.unitContent,
      Forma: "form" in elem ? elem.form.name : "",
      Sector: "sector" in elem ? elem.sector.name : "",
      SubSector: "subSector" in elem ? elem.subSector.name : "",
      Grupo: "group" in elem ? elem.group.name : "",
      Categoria: "category" in elem ? elem.category.name : "",
      Activo: (
        <Checkbox
          checked={elem.active}
          onChange={() => changeState(elem.active, elem.id)}
        ></Checkbox>
      ),
      Acciones: (
        <ProductsActionMenu
          setEditing={setEditing}
          element={elem}
          setElementToEdit={setElementToEdit}
        />
      ),
    };
    rows.push(_temp);
  });

  // return values in a format that charts components understand
  return {
    columns: [
      { Header: "#", accessor: "Nro", width: "3%" },
      { Header: "Codigo", accessor: "Codigo" },
      { Header: "Nombre", accessor: "Nombre" },
      { Header: "Fabricante", accessor: "Fabricante" },
      { Header: "Presentación", accessor: "Presentacion" },
      { Header: "Administracion", accessor: "Administracion" },
      { Header: "Contenido Unitario", accessor: "unitContent" },
      { Header: "Forma", accessor: "Forma" },
      { Header: "Sector", accessor: "Sector" },
      { Header: "SubSector", accessor: "SubSector" },
      { Header: "Grupo", accessor: "Grupo" },
      { Header: "Categoria", accessor: "Categoria" },
      { Header: "Activo", accessor: "Activo", width: "3%" },
      { Header: "Accion", accessor: "Acciones", width: "3%" },
    ],
    rows: rows,
  };
}

export default getTableData;
